var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-multiple-select',{attrs:{"value":_vm.value,"label":_vm.label,"items":_vm.roleLabelValueList,"frozen":_vm.frozen,"ready":_vm.loaded},on:{"input":function($event){return _vm.input($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }